import Vue from "vue";
import Router from "vue-router";
import pagesLegalService from "@/views/pagesLegalService/router.js";
import pagesInvestment from "@/views/pagesInvestment/router.js";
let routes = [
  {
    path: "/",
    name: "mainindex",
    component: () => import("@/views/mainindex.vue")
  },
  {
    path: "/index",
    name: "index",
    component: () => import("@/views/index.vue")
  },
  {
    path: "/elder/elderIndex",
    name: "elderIndex",
    component: () => import("@/views/elder/elderIndex.vue")
  },
  {
    path: "/elder/elderZcList",
    name: "elderZcList",
    component: () => import("@/views/elder/elderZcList.vue")
  },
  {
    path: "/elder/elderPolicyCard",
    name: "elderPolicyCard",
    component: () => import("@/views/elder/elderPolicyCard.vue")
  },

  {
    path: "/elder/elderPolicyfilelist",
    name: "elderPolicyfilelist",
    component: () => import("@/views/elder/elderPolicyfilelist.vue")
  },
  {
    path: "/elder/elderDetail",
    name: "elderDetail",
    component: () => import("@/views/elder/elderDetail.vue")
  },

  {
    path: "/zhuanlan22",
    name: "zhuanlan22",
    component: () => import("@/views/zhuanlan22.vue")
  },
  {
    path: "/zhuanlan05",
    name: "zhuanlan05",
    component: () => import("@/views/zhuanlan05.vue")
  },
  {
    path: "/zhuanlan22-02",
    name: "zhuanlan22-02",
    component: () => import("@/views/zhuanlan22-02.vue")
  },
  {
    path: "/reset2202",
    name: "reset2202",
    component: () => import("@/views/reset2202.vue")
  },
  {
    path: "/zhuanlan07",
    name: "zhuanlan07",
    component: () => import("@/views/zhuanlan07.vue")
  },
  {
    path: "/zhuanlan07-01",
    name: "zhuanlan07-01",
    component: () => import("@/views/zhuanlan07-01.vue")
  },
  {
    path: "/zhuanlan08",
    name: "zhuanlan08",
    component: () => import("@/views/zhuanlan08.vue")
  },
  {
    path: "/zhuanlan-center",
    name: "/zhuanlan-center",
    component: () => import("@/views/zhuanlan-center.vue")
  },
  {
    path: "/zhuanlan-detile",
    name: "/zhuanlan-detile",
    component: () => import("@/views/zhuanlan-detile.vue")
  },
  {
    path: "/zhuanlan-colloction",
    name: "/zhuanlan-colloction",
    component: () => import("@/views/zhuanlan-colloction.vue")
  },
  {
    path: "/zhuanlan-solve",
    name: "/zhuanlan-solve",
    component: () => import("@/views/zhuanlan-solve.vue")
  },
  {
    path: "/ComplaintList",
    name: "/ComplaintList",
    component: () => import("@/views/complaint/ComplaintList.vue")
  },
  ,
  {
    path: "/complaintdeal4",
    name: "/complaintdeal4",
    component: () => import("@/views/complaint/complaintdeal4.vue")
  },
  ,
  {
    path: "/complaintdeal6",
    name: "/complaintdeal6",
    component: () => import("@/views/complaint/complaintdeal6.vue")
  },
  ,
  {
    path: "/complaintdeal7",
    name: "/complaintdeal7",
    component: () => import("@/views/complaint/complaintdeal7.vue")
  },
  ,
  {
    path: "/complaintdeal8",
    name: "/complaintdeal8",
    component: () => import("@/views/complaint/complaintdeal8.vue")
  },
  ,
  {
    path: "/complaintdeal9",
    name: "/complaintdeal9",
    component: () => import("@/views/complaint/complaintdeal9.vue")
  },
  ,
  {
    path: "/complaintdeal10",
    name: "/complaintdeal10",
    component: () => import("@/views/complaint/complaintdeal10.vue")
  },
  {
    path: "/zhuanlan-evaluate",
    name: "zhuanlan-evaluate",
    component: () => import("@/views/zhuanlan-evaluate.vue")
  },
  {
    path: "/matchlist",
    name: "/matchlist",
    component: () => import("@/views/policymatch/matchlist.vue")
  },
  {
    path: "/copymatchlist",
    name: "copymatchlist",
    component: () => import("@/views/policymatch/copymatchlist.vue")
  },
  {
    path: "/matchdetila",
    name: "/matchdetila",
    component: () => import("@/views/policymatch/matchdetila.vue")
  },
  {
    path: "/xxtx",
    name: "/xxtx",
    component: () => import("@/views/complaint/xxtx.vue")
  },
  {
    path: "/myjianyan",
    name: "/myjianyan",
    component: () => import("@/views/policymatch/myjianyan.vue")
  },
  ,
  {
    path: "/policyfilelist",
    name: "policyfilelist",
    component: () => import("@/views/policymatch/policyfilelist.vue")
  },
  {
    path: "/policyCard",
    name: "policyCard",
    component: () => import("@/views/policyCard.vue")
  },
  {
    path: "/workindexWaper",
    name: "workindexWaper",
    component: () => import("@/views/workstate/workindexWaper.vue")
  },
  {
    path: "/workindex",
    name: "workindex",
    component: () => import("@/views/workstate/workindex.vue")
  },
  {
    path: "/workform",
    name: "workform",
    component: () => import("@/views/workstate/workform.vue")
  },
  {
    path: "/classlist",
    name: "classlist",
    component: () => import("@/views/workstate/classlist.vue")
  },

  {
    path: "/classdetile",
    name: "classdetile",
    component: () => import("@/views/workstate/classdetile.vue")
  },
  {
    path: "/publicityGuidelines",
    name: "publicityGuidelines",
    meta: {
      hideFoot: true
    },
    component: () => import("@/views/publicityGuidelines/index-phone.vue")
  },
  {
    path: "/publicityGuidelinesPc",
    name: "publicityGuidelines",
    component: () => import("@/views/publicityGuidelines/index-pc.vue")
  },
  {
    path: "/indexCard",
    name: "indexCard",
    component: () => import("@/views/featurePrefecture/indexCard.vue")
  },
  {
    path: "/moreCard",
    name: "moreCard",
    component: () => import("@/views/featurePrefecture/moreCard.vue")
  },
  {
    path: "/zrzyIndex",
    name: "zrzyIndex",
    component: () => import("@/views/featurePrefecture/zrzyIndex.vue")
  },
  {
    path: "/zrzyList",
    name: "zrzyList",
    component: () => import("@/views/featurePrefecture/list.vue")
  },

  {
    path: "/detailGeneral",
    name: "detailGeneral",
    component: () => import("@/views/featurePrefecture/detailGeneral.vue")
  },
  {
    path: "/zrzyDetail",
    name: "zrzyDetail",
    component: () => import("@/views/featurePrefecture/detail.vue")
  },
  {
    path: "/detailQs",
    name: "detailQs",
    component: () => import("@/views/featurePrefecture/detailQs.vue")
  },
  {
    path: "/zrzyListZr",
    name: "zrzyListZr",
    component: () => import("@/views/featurePrefecture/zrzyList.vue")
  },
  {
    path: "/leaveMessage",
    name: "leaveMessage",
    component: () => import("@/views/featurePrefecture/leaveMessage.vue")
  },
  {
    path: "/standingBook",
    name: "standingBook",
    component: () => import("@/views/featurePrefecture/standingBook.vue")
  },
  {
    path: "/tripartiteList",
    name: "tripartiteList",
    component: () => import("@/views/featurePrefecture/tripartiteList.vue")
  },

  {
    path: "/tripartiteDetail",
    name: "tripartiteDetail",
    component: () => import("@/views/featurePrefecture/tripartiteDetail.vue")
  },
  {
    path: "/SIdentify",
    name: "SIdentify",
    component: () => import("@/views/featurePrefecture/SIdentify.vue")
  },
  {
    path: "/gerenList",
    name: "gerenList",
    component: () => import("@/views/featurePrefecture/gerenList.vue")
  },
  {
    path: "/gerenDetail",
    name: "gerenDetail",
    component: () => import("@/views/featurePrefecture/gerenDetail.vue")
  },
  {
    path: "/freeToEnjoyList",
    name: "freeToEnjoyList",
    component: () => import("@/views/freeToEnjoy/list.vue")
  },
  {
    path: "/freeToEnjoyDetail",
    name: "freeToEnjoyDetail",
    component: () => import("@/views/freeToEnjoy/detail.vue")
  },
  {
    path: "/pagesH/certificationConsulting",
    name: "certificationConsulting",
    component: () => import("@/views/certificationConsulting/index.vue")
  },
  {
    path: "/pagesH/certificationConsulting-submit",
    name: "certificationConsulting-submit",
    component: () => import("@/views/certificationConsulting/submit.vue")
  },

  
  {
    path: "/pagesH/certificationConsulting-detail",
    name: "certificationConsulting-detail",
    component: () => import("@/views/certificationConsulting/detail.vue")
  },
  {
    path: "/pagesH/12345",
    name: "12345",
    component: () => import("@/views/12345.vue")
  },

  
  pagesLegalService,
  pagesInvestment
];
Vue.use(Router);

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new Router({
  mode: "history",
  base: '/pc/',
  routes: routes
});
router.afterEach((to, from, next) => {
  console.log(to.path);
  if (!to.meta.hideFoo) {
    document.querySelector(".zwfw_footer_common_bottom").style.display =
      "block";
  }
  console.log(from.meta.hideFoot, "qweqw");
});
export default router;
// router.beforeEach((to, from, next) => {
//   const ACCESS_TOKEN = Vue.$cookies.get('ACCESS_TOKEN')
//   if (to.path === "/login") {
//     if (ACCESS_TOKEN) {
//       next("/");
//     } else {
//       next();
//     }
//   } else {
//     if (ACCESS_TOKEN) {
//       next();
//     } else {
//       next("/login");
//     }
//   }
// })



// WEBPACK FOOTER //
// ./src/router/index.js